import {ErrorHandler, ModuleWithProviders, NgModule} from '@angular/core';
import {ApplicationinsightsAngularpluginErrorService} from './applicationinsights-angularplugin-error.service';
import {Insights} from './insights';
import {
  INSTRUMENTATION_CONFIG,
  InstrumentationConfig,
} from './instrumentation.config';


@NgModule({
  providers: [
    Insights,
    {
      provide: ErrorHandler,
      useClass: ApplicationinsightsAngularpluginErrorService,
    }
  ],
})
export class InstrumentationModule {
  constructor(private insights: Insights) {

    // https://timdeschryver.dev/blog/configuring-azure-application-insights-in-an-angular-application#sending-errors-to-application-insights
  }

  static forRoot(config: Partial<InstrumentationConfig>): ModuleWithProviders<InstrumentationModule> {

    const defaultConfig: InstrumentationConfig = {
      ignoreUrls: ['fusionauth.io',
                   'orgarena.fusionauth.io',
      ],
    };

    const mergedConfig = {...defaultConfig, ...config} as InstrumentationConfig;

    return {
      ngModule: InstrumentationModule,
      providers: [
        {provide: INSTRUMENTATION_CONFIG, useValue: mergedConfig},
      ],
    };
  }
}
